import React, {useEffect, useState} from "react";
import { Button, Dropdown, Menu } from "antd";
import { DovriyyeIcon, WhatsAppIco } from "../../../../../modules/CustomIcons";
import Icon from "@ant-design/icons";
import { Link } from "react-router-dom";
import CustomTooltip from "components/Tooltip";
import { useTranslation } from "react-i18next";
import {getMessageLists} from "store/actions/home";
import {connect} from "react-redux";





const WhatsAppNumbers: React.FC = ({messageList}) => {
    const {t} = useTranslation()
    const language = localStorage.getItem("i18nextLng")
    const [textArray, setTextArray] = useState([])
    useEffect(() => {
        const fetchessageData = async () => {
            let lang_text = messageList?.result !== undefined ? (language == "az" ? messageList.result.find(text=> text.messageKey === 'INFO.WHATSAPP')?.textAZE :
            language == "ru" ? messageList.result.find(text=> text.messageKey === 'INFO.WHATSAPP')?.textRU : language == "en" ? messageList.result.find(text=> text.messageKey === 'INFO.WHATSAPP')?.textENG : "") : "";
           const array = lang_text !== null  && lang_text !== undefined ? lang_text?.split("https://wa.me/") : [] ;
            setTextArray(array)
        };

        fetchessageData();

    }, [messageList,language])

    const NumbersDropDown = () => {

        return(
            textArray.map((line:any,index:number) => {

                return(

                    line.startsWith('994') ?
                        `<a href=${'http://wa.me/' + line} key=${index} > ${"0"+line.substring(3)} </a>
                           <br/>`
                        :
                        `<p key=${index}> ${line} </p>`
                )
            }).join(''))
    }

    // const NumbersDropDown = `
    //     <div class='flex direction_column wp_numbers'>
    //         <p>${messageList?.result !== undefined ? (language=="az" ? messageList.result[5].textAZE :
    //     language=="ru" ?  messageList.result[5].textRU : language=="en" ?  messageList.result[5].textENG:""):""}</p>
    //         <a href='tel:(077) 434-07-77'>(077) 434-07-77</a>
    //         <a href='tel:(077) 434-17-77'>(077) 434-17-77</a>
    //         <a href='tel:(077) 406-07-77'>(077) 406-07-77</a>
    //     </div>`;

    return (
        <>
            <div className='right_side_box full'>
                <div className='full right_side_box_content wp_number_section'>
                    <CustomTooltip title={NumbersDropDown()} placement={'top'} className={'wp_tooltips'}>
                        <Button type={'ghost'} icon={<WhatsAppIco />} className='transparent wp_btn flex align_center' >{t("home.contact")}</Button>
                    </CustomTooltip>
                </div>
            </div>
        </>
    )
}
const mapDispatchToProps = {
    getMessageLists
}
const mapStateToProps = (state: any) => ({
    messageList: state.home.messageList,
})
export default connect(mapStateToProps, mapDispatchToProps)(WhatsAppNumbers)

